//Styles
import * as S from './RoomPerNightUI.styles';

const RoomPerNightUI = ({roomCount = 0, roomText, showRoomText = true}) => {
  roomText = roomText || 'Room';
  return (
    <>
      <S.RoomCountText>
        {!!showRoomText ? (roomCount > 1 ? `${roomCount} ${roomText}` : `${roomText}`) : null}
      </S.RoomCountText>
      <span style={{paddingLeft: '2px'}}>per night</span>
    </>
  );
};

export default RoomPerNightUI;
